<template>
  <div class="px-4 popsorry">
    <el-dialog
      title=""
      :visible.sync="popup"
      :direction="direction"
      :before-close="handleClose"
      width="30%"
    >
      <template slot="title">
        <h3 class="fsize16 Add Products text-white">Sorry</h3>
      </template>
      <div class="">
        <div class="flex justify-center w-full">
          <img
            src="@/assets/images/new/billing.svg"
            alt="plusicon"
            class="w-32 h-32"
          />
        </div>
        <h2 class="text-xl font-semibold mt-3 text-center">
          Sorry we could not send the template
        </h2>
        <div class="flex justify-center mt-1 w-full">
          <vs-button color="primary" class="bg-primary mt-4 text-white px-7"
            >try again</vs-button
          >
        </div>
      </div>
    </el-dialog>
    <el-dialog
      title=""
      :visible.sync="popupsuccess"
      :direction="direction"
      :before-close="handleClose"
      width="30%"
    >
      <template slot="title">
        <h3 class="fsize16 Add Products text-white">Success</h3>
      </template>
      <div class="">
        <div class="flex justify-center w-full">
          <img
            src="@/assets/images/new/billing.svg"
            alt="plusicon"
            class="w-32 h-32"
          />
        </div>
        <h2 class="text-xl font-semibold mt-3 text-center">
          Template has been successfully sent
        </h2>
        <div class="flex justify-center mt-1 w-full">
          <vs-button color="primary" class="bg-primary mt-4 text-white px-7"
            >Continue</vs-button
          >
        </div>
      </div>
    </el-dialog>
    <div class="setstatic">
      <el-input placeholder="Search" v-model="Search"></el-input>
      <div class="py-2 px-3 mb-3" v-if="result.length > 0">
        <el-checkbox v-model="checkedall" @change="selectall('checked')"
          >Select all</el-checkbox
        >
      </div>
    </div>
    <div class="mt-20 pb-20 vh-hfix">
      <el-checkbox-group
        v-model="checked1"
        @change="handleCheckedCitiesChange"
        v-if="result.length > 0"
      >
        <div
          class="bg-fas p-4 bordb gap-2"
          v-for="(item, index) in result"
          :key="item"
        >
          <el-checkbox
            :label="item.mobile"
            :key="index"
            class="text-dark text-lg font-semibold"
            >{{ item.name }}</el-checkbox
          >
          <p class="text-gray text-sm font-medium mt-1 ml-8">
            {{ item.mobile }}
          </p>
          <div>
            <!-- <h2 class="text-dark text-lg font-semibold">{{ item.name }}</h2>  -->
          </div>
        </div>
      </el-checkbox-group>
      <div
        v-else
        class="px-4 flex items-center justify-center text-center w-full mt-5"
      >
        No Data
      </div>
    </div>
    <div class="flex justify-center pb-4">
      <vs-button
        color="primary"
        class="bg-primary mt-4 text-white fixed bottom-0 w-1/4"
        @click="sendtemplete"
        >Send</vs-button
      >
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      result: null,
      Search: "",
      checkedCities: [],
      checked1: [],
      recrds: [],
      input: "",
      checked: "",
      popup: false,
      checkall: false,
      toggleall: false,
      checkedall: false,
    };
  },
  props: {
    msg: String,
  },
  computed: {
    ...mapState("user", ["users"]),
    ...mapState("whatsappChat", {
      contacts: "contacts",
      showContacts: "showContacts",
      searchResults: "searchResults",
    }),
    ...mapState("admin", {
      login: "login",
    }),
  },
  watch: {
    checked1() {
      if (this.checked1.length > 0) {
        this.checkall = true;
      } else {
        this.checkall = false;
      }
    },
    Search() {
      this.getAllUsers();
    },
  },
  methods: {
    async getAllUsers() {
      try {
        const payoad = {
          perPage: 10000,
          page: 1,
        };
        if (this.Search != "") Object.assign(payoad, { search: this.Search });
        const resultt = await this.$store.dispatch("user/getAllUsers", payoad);
        console.log(resultt.registeredUser, "resulttresulttresultt");
        const unique = {};
        this.result = resultt.registeredUser.filter((obj) => {
          if (!unique[obj.mobile]) {
            unique[obj.mobile] = true;
            return true;
          }
          return false;
        });

        // this.perPage =
        // this.totalUsers = data.registeredUserLength;
        // this.$store.commit(
        //   "manageUser/GET_ALL_USER_DETAILS",
        //   data.registeredUser
        // );
        // this.users = data.registeredUser;
      } catch (error) {
        console.log(error);
      }
    },
    async reset() {
      this.checked1 = [];
    },
    async sendtemplete() {
      if (this.checked1.length == 0) {
        // this.popup = true;
        this.$swal({
          text: "Please select a recipient",
          icon: "warning",
          confirmButtonColor: "#CD3197",
          confirmButtonText: "OK",
        });
      } else {
        for (let i = 0; i < this.checked1.length; i++) {
          const payload = {
            destination: "91" + this.checked1[i],
            message: { isHSM: true, type: "text", text: this.msg },
            username: this.login.name || "",
          };
          try {
            await this.$store.dispatch("whatsappChat/sendMessage", payload);
          } catch (err) {
            console.log(err);
          }
        }
        this.$swal({
          text: "Template sent successfully",
          icon: "success",
          confirmButtonColor: "#CD3197",
          confirmButtonText: "OK",
        });
        this.reset();
        this.$emit("closeSlider");
      }
    },

    selectall(x) {
      console.log(this.contacts, "contactscontactscontacts");
      if (this.checkedall == false) {
        this.checked1 = [];
      }
      if (this.checkedall == true) {
        this.checked1 = [];
        this.users.map((val) => {
          this.checked1.push(val.mobile);
        });
      }
    },
  },
  async mounted() {
    const unique = {};
    this.result = this.users.filter((obj) => {
      if (!unique[obj.mobile]) {
        unique[obj.mobile] = true;
        return true;
      }
      return false;
    });

    this.users.map((x) => {
      this.recrds.push({
        name: x.name,
        mobile: x.mobile,
      });
    });
    console.log(this.recrds, "recrdsrecrdsrecrds");
  },
};
</script>
<style>
.setstatic {
  position: fixed;
  background: #fff;
  z-index: 90000;
  width: 100%;
  top: 70px;
}

.vh-hfix {
  height: 75vh;
  overflow-y: auto;
  overflow-x: hidden;
}
</style>
